(function () {
    'use strict';

    angular
        .module('actionPlanCriteriaModule')
        .directive('grcActionPlanCriteria', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn', 'grcActionPlanCriteriaService', 'followUpService', 'recomActionPlanUpdateStatusService'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn, grcActionPlanCriteriaService, followUpService, recomActionPlanUpdateStatusService) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addActionPlanCriteria = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope', '$controller', '$state', 'recomConstants', function ($scope, $controller, $state, recomConstants) {
                // set feature role if it is on object.
                if ($scope.boxModel && $scope.boxModel.RecomBusinessUnit && $scope.boxModel.RecomBusinessUnit.FeatureRole){
                    $scope.boxFeatureRole = $scope.boxModel.RecomBusinessUnit.FeatureRole;
                }

                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/actionPlanCriteria/grcActionPlanCriteria.[Template].tpl.html';
                // Permissions default values
                $scope.boxFeatureRole = $scope.boxFeatureRole || recomConstants.featureRoles;
                $scope.boxPermissionKey = $scope.boxPermissionKey || 'ActionPlanCriteria';

                $controller('BoxTmplController', { $scope: $scope });

                $scope.readOnly = !$scope.boxPermissions.Edit;

                // Have dates the same day?
                $scope.haveDatesTheSameDay = function (date1, date2) {

                    if (_.isUndefined(date1)) return;
                    if (_.isUndefined(date2)) return;

                    if (!moment.isMoment(date1)) date1 = moment(date1);
                    if (!moment.isMoment(date2)) date2 = moment(date2);

                    var isSameDay = date1.isSame(date2, 'day');
                    return isSameDay;
                };

                // Edit Model Part
                $scope.editModelPart = function (criteria) {
                    $state.go('recommendation.edit.actionPlan.edit.actionPlanCriteriaEdit', {
                        ActionPlanCriteriaID: criteria.ActionPlanCriteriaID
                    }, {
                        location: 'replace'
                    });
                };

                // Show open followUps action?
                $scope.showOpenFollowUpsAction = function () {
                    return !$scope.boxModel.ActionPlanCriteriaID;
                };

                // Open Followups
                $scope.openFollowups = function ($event) {
                    $event.stopPropagation();
                    grcActionPlanCriteriaService
                        .getFollowUpListByActionPlanCriteria(
                            $scope.boxModel.ActionPlanID,
                            $scope.boxModel.ActionPlanCriteriaID)
                        .then(function (critAssContainers) {
                            followUpService.openFollowUpsModal($scope.boxModel.TitleEN,
                                                              null,
                                                              null,
                                                              critAssContainers,
                                                              getDownloadAttachmentUrl);
                        });
                };

                function getDownloadAttachmentUrl(attachmentId, criteriaAssessment) {

                    return recomActionPlanUpdateStatusService
                        .getDownloadAttachmentUrl(
                            $scope.boxModel.RecomBusinessUnitID,
                            $scope.boxModel.ActionPlanID,
                            $scope.boxModel.ActionPlanCriteriaID,
                            criteriaAssessment.ActionPlanCriteriaAssessmentID,
                            attachmentId);
                }

            }],

            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();